import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["iconProps"];

/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
export var SpinningLoadingIcon = function SpinningLoadingIcon(props) {
  return /*#__PURE__*/React.createElement(LoadingOutlined, _extends({
    spin: true
  }, props));
};

var LoadingSpinner = function LoadingSpinner(_ref) {
  var iconProps = _ref.iconProps,
      spinProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Spin, _extends({
    indicator: /*#__PURE__*/React.createElement(SpinningLoadingIcon, iconProps)
  }, spinProps));
};

export default LoadingSpinner;